// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"0":"6e0fac21","20":"c8743637","39":"0dcd018c","68":"4ee2cadf","405":"ad394b6e","411":"eb625b40","488":"796b92ea","625":"2f901a23","775":"a4631e93","813":"570e224d"}[chunkId] + ".chunk.js";
};